import api from '../../utils/api';
import history from '../../utils/history';
import { alertError, alertSuccess } from './alert';
import { RESET_PASSWORD_ERROR_MESSAGE } from '../constants/signUpTypes';

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;

export const resetPasswordErrorMessage = (errorCode) => ({ type: RESET_PASSWORD_ERROR_MESSAGE, payload: errorCode });

export const createNewPassword = (new_password, token) => (dispatch) => {
  const params = { new_password, token };

  if (!passwordRegex.test(new_password)) {
    return dispatch(resetPasswordErrorMessage('INSECURE_PASSWORD'));
  }

  api
    .post('/users/resetPassword', params)
    .then((response) => {
      if (response.data.message !== '' || response.data.success) {
        dispatch(alertSuccess('Password was reset successfully'));
      }
      history.push('/signin');
    })
    .catch((error) => {
      if (error.response && error.response.data && error.response.data.code) {
        return dispatch(resetPasswordErrorMessage(error.response.data.code));
      }

      return dispatch(alertError(error));
    });
};
